<sh-form-four-state-checkbox
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [control]="control$ | async"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [title]="disabledMessageKey | translate"
    [indeterminateMsg]="'general.different-values' | translate"
>
    <ng-content></ng-content
></sh-form-four-state-checkbox>
